import { createAction } from '@reduxjs/toolkit';
import {
  IApiProgressPayload,
  IApiSuccessPayload,
  IApiErrorPayload,
  IApiRequestConfig,
} from '../types';

export const API_REQUEST = 'api-request';
export const API_REQUEST_PROGRESS = 'api-request/pending';
export const API_REQUEST_SUCCESS = 'api-request/succeed';
export const API_REQUEST_ERROR = 'api-request/rejected';

export const ApiRequest = createAction<IApiRequestConfig>(API_REQUEST);
export const ApiRequestProgress = createAction<IApiProgressPayload>(API_REQUEST_PROGRESS);
export const ApiRequestSucceed = createAction<IApiSuccessPayload>(API_REQUEST_SUCCESS);
export const ApiRequestError = createAction<IApiErrorPayload>(API_REQUEST_ERROR);
